export class Currency {
    constructor({ insuranceForm, state }) {
        this._lang = $('html').attr('lang');
        this.$insuranceForm = insuranceForm;
        this._state = state;
    }

    showCurrencySelection() {
        $('.clients_wrapper').before(`
            <div class="checkout_form_row currency_wrapper">
                <div class="checkout_form_field _required">
                    <label for="currency">Валюта</label>
                    <select required id="currency" name="currency" class="selectize select1">
                        <option value="eur">Euro</option>
                        <option value="usd">Usd</option>
                    </select>
                </div>
            </div>
        `);

        $('.currency_wrapper #currency').selectize({
            onItemAdd: this._selectCurrency.bind(this),
        });
    }

    hideCurrencySelection() {
        $('.currency_wrapper').remove();
    }

    _selectCurrency(value) {
        this._state.currency = value;
    }
}